import * as moment from 'moment';

import { IApplicationConfiguration, IDatePickerDates, IFrequency, Interval, TimeUnit } from '../../models';
import { IDateRangePickerService, toDuration } from './index';

export interface IGroupEnforceAlignService {
    groupEnforceAlign(datePickerDates: IDatePickerDates, groupFrequency: IFrequency, appConfiguration: IApplicationConfiguration, isSinglePeriod: boolean): IDatePickerDates;
    initializeSinglePeriod(dateParam: string, frequency: IFrequency, application: IApplicationConfiguration, interval: Interval, isSinglePeriod: boolean): IDatePickerDates;
}

export class GroupEnforceAlignService implements IGroupEnforceAlignService {
    static serviceId = 'groupEnforceAlignService';

    private _intervalUnitGreaterThanDay = [TimeUnit.Week, TimeUnit.Month, TimeUnit.Year];

    static $inject = [
        'dateRangePickerService'
    ];

    constructor(
        private _dateRangePickerService: IDateRangePickerService
        ) {
    }

    groupEnforceAlign(dates: IDatePickerDates, groupFrequency: IFrequency, appConfiguration: IApplicationConfiguration, isSinglePeriod: boolean): IDatePickerDates {
        let aligned: IDatePickerDates = dates;

        // fall-back on app frequency
        const freq = groupFrequency.interval === 0
            ? { interval: appConfiguration.interval, intervalTimeUnit: appConfiguration.intervalTimeUnit }
            : groupFrequency;
        const alignBeginOnPrevious = (this._intervalUnitGreaterThanDay.indexOf(groupFrequency.intervalTimeUnit) >= 0
                                        || groupFrequency.intervalTimeUnit === TimeUnit.Day && groupFrequency.interval > 1);
        if (!this._dateRangePickerService.isAligned(dates, freq, appConfiguration)) {
            aligned = this._dateRangePickerService.enforceAlign(dates, freq, appConfiguration, alignBeginOnPrevious);
            if (aligned.startDate.isSame(aligned.endDate)) {
                // Must be hella wrong on DST change day
                aligned.endDate.add(toDuration(freq));
            }
        }
        return aligned;
    }

    initializeSinglePeriod(dateParam: string, frequency: IFrequency, application: IApplicationConfiguration, interval: Interval, isSinglePeriod: boolean): IDatePickerDates {
        const startMoment = moment(dateParam);
        const endMoment = startMoment.clone();
        const alignedRange = this.groupEnforceAlign(
            { startDate: startMoment, endDate: endMoment },
            frequency,
            application,
            isSinglePeriod
        );
        let endDate = alignedRange.endDate;
        if (endDate.isSame(endMoment)) {
            // Must be hella wrong on DST change day
            endDate = endMoment.add(interval.interval, interval.unit);
        }
        return {
            startDate: alignedRange.startDate,
            endDate
        };
    }
}